import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../app/hooks";
import { useEffect, useState } from "react";
import ContentOverlay from "../components/ContentOverlay";
import { setReturnUrl } from "../features/config/configSlice";
import { setHotelConfiguration } from "../helpers/hotels";
import { useTranslation } from "react-i18next";

export default function RedirectHotel({ hotelCode }: { hotelCode: string }) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [overlayContent, setOverlayContent] = useState<string>("");
  const { t } = useTranslation();

  const getSelectedHotel = (HotelCode: string) => {

    /**
     * Get the returnUrl from the URL parameters and store it in the Redux store
     * This is used when a user comes from the kiosk and needs to return to the kiosk.
     */
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get('returnUrl')
    dispatch(setReturnUrl(returnUrl));

    const fetchConfig = async () => {
      return await setHotelConfiguration({ HotelCode: HotelCode });
    };

    fetchConfig().then(() => {
      // Navigate to the calendar after a short delay to allow state to update
      setTimeout(() => {
        navigate("/calendar");
      }, 500);

    });
  };

  useEffect(() => {
    setOverlayContent(t('scenes.redirectHotel.message'));
    getSelectedHotel(hotelCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <ContentOverlay show={true} content={overlayContent} />;
}
